// Deterministic per-point jitter for categorical axes. Applied at render so
// overlapping points (many sims share a category index) spread out, while saved
// and shared plots stay pixel-identical (no randomness).

// Total spread around the category index; points land within +/- half of this.
// Kept well under the 1.0 lane width so each category reads as a tight column
// with clear gutters to its neighbors' lane dividers.
const JITTER_SPREAD = 0.36

function hashString(seed: string): number {
  let hash = 0
  for (let i = 0; i < seed.length; i++) {
    hash = (hash * 31 + seed.charCodeAt(i)) | 0
  }
  return hash >>> 0
}

// Stable offset in [-JITTER_SPREAD/2, JITTER_SPREAD/2) keyed by sim id + axis.
export function categoryJitter(
  simulationOutputId: string,
  axis: "x" | "y",
): number {
  const unit = (hashString(`${simulationOutputId}:${axis}`) % 1000) / 1000
  return (unit - 0.5) * JITTER_SPREAD
}
